<nav *ngIf="isMobile" role="navigation" aria-labelledby="block-un3-sc-mainnavigation-menu" id="block-un3-sc-mainnavigation" class="block block-menu navigation menu--main">
      
    <h2 id="block-un3-sc-mainnavigation-menu" class="block-title">

        <a (click)="closeMenu()" href="javascript:void(0)" data-bs-toggle="collapse" class="" aria-expanded="true">Menu</a>

    </h2>


        <div class="show block-content">
    
            <ul class="clearfix nav navbar-nav core-nav">

                <li *ngFor="let menu of igovService.menus(); ; let i = index" class="nav-item menu-item--expanded dropdown">
                    <a href="javascript:void(0)" 
                    id="dropdownMenuButton{{ i }}" 
                    class="nav-link dropdown-toggle nav-link--securitycouncil-en-content-what-security-council d-flex gap-s align-items-center justify-content-between" 
                    data-bs-toggle="dropdown"
                    aria-expanded="false">{{menu.title}}</a>
                    <ul class="dropdown-menu" [attr.aria-labelledby]="'dropdownMenuButton' + i">
                        
                                <li *ngFor="let child of menu.child">
                                    <a (click)="navigate(child.link)" [routerLink]="child.link" class="dropdown-item nav-link--securitycouncil-en-content-functions-and-powers d-flex gap-s align-items-center justify-content-between">{{child.title}}</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
</nav>